export default __webpack_public_path__ + "static/media/pixellab--graphic-design--03--600x450.c7b44414.jpg";